import { formatDate } from "../../../utils/dateUtils";

export const groupChatsByDate = (chats) => {
  const groups = {};
  chats?.forEach((chat) => {
    const dateStr = formatDate(chat.datePosted);
    if (!groups[dateStr]) {
      groups[dateStr] = [];
    }
    groups[dateStr].push(chat);
  });
  return groups;
};
